import React from 'react';
import { Button, CircularProgress } from '@material-ui/core';

const PrimaryButton = ({ style = {}, onClick, isLoading, disabled, fullWidth, children }) => <Button
    style={{
        minWidth: '120px',
        height: '40px',
        fontSize: '17px',
        fontWeight: '700',
        ...style
    }}
    variant="contained"
    color="primary"
    disabled={isLoading || disabled}
    fullWidth={fullWidth}
    onClick={onClick}>
    {isLoading ? <CircularProgress
        size={20}
        color='primary'
        role="status"
        aria-hidden="true" /> : children}
</Button>

export default PrimaryButton;